<app-icon class="icon"
          library="fontawesome"
          variant="{{variant}}"
          [simple]="true">
</app-icon>
<span *ngIf="text" class="text">{{ text }}</span>
